<form autocomplete="off" class="form mx-4 mb-3" style="padding-top: 20px">
  <div class="columns">
    <div class="column is-5">
      <lng-lat-fields
        (onLatChange)="handleFieldChange($event, 'pointLat', ['building'])"
        (onLngChange)="handleFieldChange($event, 'pointLng', ['building'])"
        [lng]="getField(['building', 'pointLng'])"
        [lat]="getField(['building', 'pointLat'])"
        [latError]="
          hasError('building.pointLat') && getError('building.pointLat')
        "
        [lngError]="
          hasError('building.pointLng') && getError('building.pointLng')
        "
        [isReadonly]="!(!isReadonly && hasPinEditPermission)"
      ></lng-lat-fields>
      <div class="columns" style="width: 100%">
        <div class="column is-5">
          <div class="field">
            <label class="label" translationEditableDirective="ROOF_TOP_AREA">{{
              'ROOF_TOP_AREA' | translate
            }}</label>
            <div class="control has-icons-right">
              <input
                *ngIf="!isReadonly && hasAreaEditPermission"
                class="input is-small"
                name="area"
                type="text"
                (input)="handleFieldChange($event, null, ['building'])"
                [value]="getField(['building', 'area'])"
                [ngClass]="{ 'is-danger': hasError('building.area') }"
              />
              <span *ngIf="isReadonly || !hasAreaEditPermission"
                >{{ getField(['building', 'area']) }}
                {{ settings.SETTINGS_UNITS_AREA_SYMBOL }}</span
              >

              <span
                *ngIf="!isReadonly && hasAreaEditPermission"
                class="icon is-small is-right"
                style="color: black"
              >
                {{ settings.SETTINGS_UNITS_AREA_SYMBOL }}
              </span>
            </div>
            <p class="help is-danger" *ngIf="hasError('building.area')">
              {{ getError('building.area') }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="layers"
        style="width: 100%"
        [formGroup]="layers"
        *ngIf="activeLayers && activeLayers.length"
      >
        <div class="layers-head-row">
          <div>{{ 'LAYER' | translate }}</div>
          <div>{{ 'VALUE' | translate }}</div>
          <div></div>
        </div>
        <div
          class="layers-row"
          formArrayName="rows"
          *ngFor="let layer of activeLayers; let i = index"
        >
          <span class="layers-row-name"
            >{{ layer.get('name').value }}
            <span *ngIf="layer.get('calculation').value">
              {{
                getCalculationValue(layer.get('feature').value)
                  ? getCalculationValue(layer.get('feature').value) + '%'
                  : ''
              }}
              <img
                [tooltip]="'CALCULATION' | translate"
                src="/assets/calculate-math-icon.svg"
              />
            </span>
          </span>
          <div [formGroupName]="i">
            <ng-select
              [items]="layer.get('features').value"
              [multiple]="false"
              [closeOnSelect]="true"
              bindLabel="label"
              bindValue="id"
              class="is-fullwidth is-small"
              formControlName="feature"
              *ngIf="!isReadonly"
              [placeholder]="'NONE' | translate"
            >
            </ng-select>
            <span *ngIf="isReadonly">
              <span
                *ngIf="
                  getSelectedFeatureById(
                    layer.get('feature').value,
                    layer.get('features').value
                  )
                "
                >{{
                  getSelectedFeatureById(
                    layer.get('feature').value,
                    layer.get('features').value
                  )
                }}</span
              >
              <span
                translationEditableDirective="NONE"
                *ngIf="
                  !getSelectedFeatureById(
                    layer.get('feature').value,
                    layer.get('features').value
                  )
                "
                >{{ 'NONE' | translate }}</span
              >
            </span>
          </div>
          <div>
            <button
              *ngIf="!isReadonly"
              (click)="detect(layer.get('id').value)"
              type="button"
              class="button is-text is-small is-fullwidth"
              translationEditableDirective="DETECT"
            >
              {{ 'DETECT' | translate }}
            </button>
          </div>
        </div>

        <div *ngIf="!isReadonly" class="is-flex is-justify-content-end">
          <div
            class="ml-auto is-flex is-justify-content-center detect-all"
            style="width: 110.5px"
          >
            <button
              type="button"
              class="button is-info is-small my-2"
              translationEditableDirective="DETECT_ALL"
              (click)="detectAll()"
            >
              {{ 'DETECT_ALL' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-7">
      <measure-map
        [isReadonly]="isReadonly"
        [layerFeatures]="layerFeatures"
        *ngIf="state.get('data').size"
        [lng]="getField(['building', 'pointLng'])"
        [lat]="getField(['building', 'pointLat'])"
        [polygon]="polygon"
        (polygonChange)="onPolygonChange($event)"
        (markerChange)="onMarkerChange($event)"
        [canPinEdit]="hasPinEditPermission"
        [canPolygonEdit]="hasPolygonEditPermission"
      >
      </measure-map>
    </div>
  </div>
</form>
